import React from 'react';
import { FormattedMessage } from 'react-intl';
import { makeStyles, Typography } from '@material-ui/core';
import { getTextInBold } from '~/modules/common/util';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.text.secondary,
    padding: theme.spacing(1, 2),
    margin: theme.spacing(-2, -2, 2, -2)
  },
  hintLabel: {
    fontWeight: theme.typography.fontWeightBold,
    marginRight: theme.spacing(0.5)
  }
}));

const ResumeCardUserHint = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography variant="body2" component="span">
        <FormattedMessage id="resumeCard.userHint" values={getTextInBold()} />
      </Typography>
    </div>
  );
};

export default ResumeCardUserHint;
